import styled from 'styled-components';
const StyledH2 = styled.h2 `
    position: relative;
    font-family: ${props => props.theme.fontHead};
    color: ${props => props.theme.primary.base};
    font-weight: 600;
    margin-bottom: 30px;
    padding-bottom: 8px;
    font-size: 18px;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 38px;
        height: 3px;
        background-color: ${props => props.theme.headingHighlight};
        border-radius: 2px;
    }
`;
export default StyledH2;
